
import { defineComponent } from 'vue'
import { mapState } from 'vuex'
import AsahiSelectHeader from '@/components/library/AsahiSelectHeader.vue'
import AsahiProgressBar from '@/components/library/assets/AsahiProgressBar.vue'
import { permissionSchema, RolePermissionDetails } from '@/store/modules/users/interfaces/IUser'
import { getLocaleKeyForTransportationTypes, mapTransportType, TransportationTypes } from '@/utils/transportTypes'
import { IAuthUser } from '@/store/modules/auth/interfaces/IAuthUser'
import { IShipToBySapId } from '@/store/modules/catalog/interfaces/shipto/IShipToResponse'
import DeliveryDatePicker from '@/components/cart/DeliveryDatePicker.vue'
import {
  getHolidayDays,
  isExceptionDeliveryDate,
  isStandardDeliveryDate,
  validateDeliveryDate
} from '@/utils/deliveryDate'
import shipToIcon from '@/components/library/assets/shipToBlack.svg'
import whiteShipToIcon from '@/components/library/assets/shipTo.svg'
import addToCartIcon from '@/components/library/assets/goldenPlus.svg'
import suggestedCartIcon from '@/components/library/assets/star.svg'
import trackIcon from '@/components/library/assets/TruckBlack.svg'
import whiteTruckIcon from '@/components/library/assets/Truck.svg'
import calendarIcon from '@/components/library/assets/CalendarWhite.svg'
import { BaseCartQueryItem, LastCustomerSettings } from '@/store/modules/basket/interfaces/cartQuery/ICartQueryResponse'
import ContinueShoppingModal from '@/components/modals/ContinueShoppingModal.vue'
import modals from '@/utils/modals'
import formatDateMixin from '@/utils/mixin'
import AsahiButton from '@/components/library/AsahiButton.vue'
import AngleUpDownIcon from '@/components/library/icons/AngleUpDownIcon.vue'
import DeliveredIcon from '@/components/library/icons/DeliveredIcon.vue'
import { CalendarExceptions, ShipToOptions } from '@/store/modules/deliveryDates/interfaces/calendarException'
import ExclamationIcon from '@/components/library/icons/ExclamationIcon.vue'
import { setDeliveryDate } from '@/utils/orderDetails'
import { hasPOSMOrder, showSuggestedCart } from '@/utils/user'
import { CommonActionType } from '@/store/modules/common/action-type'

import { apolloClient } from '@/store/graphql.config'
interface NavigateLink {
  name: string
  label: string
  href?: string
  link?: string
  target?: string
  isActive?: boolean
}

interface HeaderData {
  label: string
  children: any[]
  name: string
  href?: string
}
const MORE_SECTION_META_VALUES = ['marketing', 'news']
const CREATE_ORDER_NAME = 'Create an order'
const SHIP_TO_IDS_FOR_SMALL_TRUCK = [
  '1123069', '1128540', '1128541', '1132153', '1378446', '1451527', '1078585',
  '1106931', '1155500', '1147836', '1146023', '1153964', '1085003', '1084773',
  '1075622', '1093683', '1100456', '1579306', '1158332', '1539502', '1156832',
  '1604126', '1128540', '1128541', '1129556', '1129606', '1413065', '1080720',
  '1152086', '1152468', '1152760', '1273610', '1156069', '1149863', '1089260',
  '1104514', '1416172', '1266582', '1080721', '1320552', '1066949', '1148930',
  '1168627', '1113875', '1125857', '1375235', '1108869', '1438029', '1131934',
  '1132317', '1095627', '1112567', '1151988', '1521734', '1542465', '1115492',
  '1115496', '1115660', '1141697', '1142453', '1123069', '1063410', '1703422',
  '1063964', '1146401', '1073245', '1157566', '1064844', '1111689', '1155548',
  '1148854', '1148931', '1148984', '1117107', '1111029', '1143037', '1062195',
  '1144026', '1145460', '1146945', '1067872', '1266603', '1158660', '1152186',
  '1100463', '1132153', '1098807', '1150786', '1468275', '1542466', '1155717',
  '1102307', '1148668', '1090907', '1394830', '1170955', '1158810', '1151697',
  '1106753', '1090103', '1102368', '1127244', '1098841', '1129290', '1708572',
  '1266598', '1266585', '1163069', '1139246', '1085432', '1140959', '1155526',
  '1155525', '1266600', '1155499', '1605455', '1142682', '1084086', '1245819',
  '1173894', '1184254', '1184315', '1269775', '1063796', '1274183', '1275964',
  '1542467', '1335755', '1351099', '1353708', '1378446', '1548509', '1451527',
  '1465188', '1561033', '1469448', '1542464', '1535243', '1541037', '1543956',
  '1549221', '1554637', '1558094', '1561116', '1572062', '1573557', '1612569',
  '1576040', '1458396', '1600847', '1602373', '1602391', '1603558', '1604231',
  '1612578', '1616018', '1619699', '1701405', '1704801', '1707777', '1465230'
]

const USER_TYPES_UNFILTERED = ['POS UNFILTERED BEER', 'WHS UNFILTERED BEER']

export default defineComponent({
  components: { ExclamationIcon, DeliveredIcon, AngleUpDownIcon, AsahiButton, DeliveryDatePicker, AsahiSelectHeader, AsahiProgressBar },
  mixins: [formatDateMixin],
  props: {
    changeMessageColor: {
      type: Boolean,
      default: false
    },
    filterTransportations: {
      type: Array as () => Array<TransportationTypes>,
      default: undefined
    },
    isSuggestedCart: {
      type: Boolean,
      default: false
    },
    suggestedShipToId: {
      type: String,
      default: null
    },
    cartId: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      shipToIcon,
      whiteShipToIcon,
      trackIcon,
      whiteTruckIcon,
      calendarIcon,
      selectedShipmentId: '',
      errorMsg: '',
      successWeight: false,
      errorWeight: false,
      shipmentSet: false,
      selectedOrderType: '',
      deliveryDateSelected: '' as string,
      shipTo: {},
      billingAddressForm: {} as any,
      options: [] as any,
      deliveryDatePickerHeight: 0,
      isExpanded: false,
      bufferedSelection: {} as any,
      isDatePickerOpen: false,
      orderInfo: null as any | null,
      addToCartIcon,
      suggestedCartIcon,
      addToCartLabel: '',
      hideCta: false
    }
  },
  computed: {
    isGigyaFallback () {
      return this.$store.state.auth.isGigyaFallback
    },
    isDeliveryDateFallback () {
      return this.$store.state.deliveryDates.isDeliveryDateFallback
    },
    ...mapState('basket', ['id', 'query', 'shipmentId', 'deliveryDate', 'items', 'paymentMethod', 'availableDate', 'customerSettings', 'isGroupedViewEnabled']),
    ...mapState('catalog', ['alignment', 'shipTos']),
    ...mapState('main', ['holidaysConfig']),
    ...mapState('auth', ['user']),
    ...mapState('deliveryDates', ['availableDays', 'filteredDeliveryDates', 'posmInventoryDates']),
    calendarException () {
      return this.$store.state.deliveryDates.notificationExceptions
    },
    portalPageMenuLink () {
      return this.$store.state.links.portalPageMenuLink?.items ?? []
    },
    showSuggestedCart,
    isCatalogVisible (): boolean {
      return true
    },
    isOnSuggestedCart (): boolean {
      return this.$route?.path === '/catalog/suggested-cart'
    },
    isMoreSection (): boolean {
      return MORE_SECTION_META_VALUES.includes(this.$route?.meta?.tabSelection as string)
    },
    formattedDeliveryDate () {
      if (!this.deliveryDate) return ''
      const args = this.deliveryDate.split('-')
      return args[2] + '.' + args[1]
    },
    currentShippingPlace () {
      return this.shipToOptions.find((s: any) => s.value === this.selectedShipmentId)
    },
    currentShippingMethod () {
      return this.transportOptionsAsSelectBoxOptions.find((t: any) => t.value === this.shipmentId)
    },
    shipToOptions (): {label: string, value: string, description: string, hasCalendarException: boolean}[] {
      const { permissionSchema = [] } = this.user || {}
      const isGigyaFallback = this.$store.state.auth.isGigyaFallback
      return permissionSchema
        .filter((permission: any) =>
          isGigyaFallback
            ? true
            : permission.rpDetails.some(
              (role: any) =>
                role.permission.includes('Catalogue') &&
                  permission.shipToStatus === 'APPROVED'
            )
        )
        .map((permission: any) => ({
          label: permission.shipToName,
          value: permission.shipToId,
          description: permission?.shipToAddress,
          hasCalendarException: this.hasShipToCalendarException(permission)
        }))
    },
    hasSelectedShipmentCalendarException () {
      if (this.isDeliveryDateFallback || this.isGigyaFallback) return false
      return this.shipToOptions.some(
        (option) => option.value === this.selectedShipmentId && option.hasCalendarException
      )
    },
    progressBar () {
      return this.query?.progress_bar_data
    },
    maxOrderCash () {
      return this.progressBar?.iMaximumOrderCash ?? 0
    },
    grandTotalYourPrice () {
      return this.query?.grand_total_your_price_details?.grand_total_your_price ?? 0
    },
    cashFilledPercentage () {
      return (this.grandTotalYourPrice / this.maxOrderCash) * 100
    },
    messageColorClass () {
      let msgColor = ''
      let borderColor = ''
      if (this.changeMessageColor) {
        if (this.errorWeight) {
          msgColor = 'error-text'
          borderColor = 'border-error-text'
        } else if (this.successWeight) {
          msgColor = 'success-text'
          borderColor = 'border-success-text'
        } else {
          msgColor = 'default-text'
          borderColor = 'border-default-text'
        }
      }
      return { msgColor, borderColor }
    },
    filteredTransportOptions () {
      if (this.filterTransportations && this.filterTransportations.length) {
        return this.transportOptions.filter((option: any) => {
          if (this.isSuggestedCart &&
            (option.value === 'emptiespickup_emptiespickup' ||
              option.value === 'emptiesfulltruck_emptiesfulltruck')) {
            return false
          } else {
            return this.filterTransportations?.includes(option.value)
          }
        })
      } else {
        return this.transportOptions.filter((option: any) => {
          return !(this.isSuggestedCart &&
            (option.value === 'emptiespickup_emptiespickup' ||
              option.value === 'emptiesfulltruck_emptiesfulltruck'))
        })
      }
    },
    transportOptions () {
      if (this.shipTos?.length > 0) {
        const customerType = this.shipTos.length > 0
          ? this.user.permissionSchema.filter((item: any) => item.shipToId === this.shipTos[0].shiptosapid).map((permission: any) => {
            return {
              value: permission.rpDetails[0].customerType
            }
          })
          : ''
        const fullTruck = this.shipTos.find((item: IShipToBySapId) => item.type === 'PD')
        const smallTruck = this.shipTos.find((item: IShipToBySapId) => item.type !== null && item.type.includes('1'))
        const transports = [] as any

        if (smallTruck) {
          transports.push(
            {
              label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.SMALL)),
              value: TransportationTypes.SMALL,
              checked: this.selectedOrderType === 'selfpickup_selfpickup',
              hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.SMALL))
            }
          )
        }
        if (SHIP_TO_IDS_FOR_SMALL_TRUCK.includes(this.selectedShipmentId) && !this.isGigyaFallback && !this.isDeliveryDateFallback) {
          transports.push({
            label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.SMALL_TRUCK)),
            value: TransportationTypes.SMALL_TRUCK,
            checked: this.selectedOrderType === 'freeshipping_freeshipping',
            hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.SMALL_TRUCK))
          })
        }
        if (fullTruck && !this.isGigyaFallback && !this.isDeliveryDateFallback) {
          transports.push(
            {
              label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.TRUCK)),
              value: TransportationTypes.TRUCK,
              checked: this.selectedOrderType === 'flatrate_flatrate',
              hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.TRUCK))
            }
          )
        }
        if (this.checkTankEnabled() && !this.isGigyaFallback && !this.isDeliveryDateFallback) {
          transports.push({
            label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.TANK)),
            value: TransportationTypes.TANK,
            checked: this.selectedOrderType === 'tant_tank',
            hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.TANK))
          })
        }
        if (this.checkUnfilteredAreEnabled() && !this.isGigyaFallback && !this.isDeliveryDateFallback) {
          transports.push({
            label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.UNFILTERED)),
            value: TransportationTypes.UNFILTERED,
            checked: this.selectedOrderType === 'unfiltered_unfiltered',
            hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.UNFILTERED))
          })
        }
        if (hasPOSMOrder() && !this.isGigyaFallback && !this.isDeliveryDateFallback) {
          transports.push({
            label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.POSM)),
            value: TransportationTypes.POSM,
            checked: this.selectedOrderType === 'posm_posm',
            hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.POSM))
          })
        }
        if (smallTruck && !this.isGigyaFallback && !this.isDeliveryDateFallback) {
          transports.push({
            label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.EMPTY_SMALL)),
            value: TransportationTypes.EMPTY_SMALL,
            checked: this.selectedOrderType === 'emptiespickup_emptiespickup',
            hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.EMPTY_SMALL))
          })
        }
        if (!(this.user.country === 'SVK' && customerType[0]?.value === 'POS') && fullTruck && !this.isGigyaFallback && !this.isDeliveryDateFallback) {
          transports.push(
            {
              label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.EMPTY_TRUCK)),
              value: TransportationTypes.EMPTY_TRUCK,
              checked: this.selectedOrderType === 'emptiesfulltruck_emptiesfulltruck',
              hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.EMPTY_TRUCK))
            }
          )
        }
        return transports
      }
      return [
        {
          label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.SMALL)),
          value: TransportationTypes.SMALL,
          checked: this.selectedOrderType === 'selfpickup_selfpickup',
          hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.SMALL))
        },
        {
          label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.SMALL_TRUCK)),
          value: TransportationTypes.SMALL_TRUCK,
          checked: this.selectedOrderType === 'freeshipping_freeshipping',
          hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.SMALL_TRUCK))
        },
        {
          label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.TRUCK)),
          value: TransportationTypes.TRUCK,
          checked: this.selectedOrderType === 'flatrate_flatrate',
          hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.TRUCK))
        },
        {
          label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.UNFILTERED)),
          value: TransportationTypes.UNFILTERED,
          checked: this.selectedOrderType === 'unfiltered_unfiltered',
          hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.UNFILTERED))
        },
        {
          label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.TANK)),
          value: TransportationTypes.TANK,
          checked: this.selectedOrderType === 'tank_tank',
          hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.TANK))
        },
        {
          label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.POSM)),
          value: TransportationTypes.POSM,
          checked: this.selectedOrderType === 'posm_posm',
          hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.POSM))
        },
        {
          label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.EMPTY_SMALL)),
          value: TransportationTypes.EMPTY_SMALL,
          checked: this.selectedOrderType === 'emptiespickup_emptiespickup',
          hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.EMPTY_SMALL))
        },
        {
          label: this.$t(getLocaleKeyForTransportationTypes(TransportationTypes.EMPTY_TRUCK)),
          value: TransportationTypes.EMPTY_TRUCK,
          checked: this.selectedOrderType === 'emptiesfulltruck_emptiesfulltruck',
          hasCalendarException: this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.EMPTY_TRUCK))
        }
      ].filter((option: any) => (!this.isGigyaFallback && !this.isDeliveryDateFallback) || option.value === TransportationTypes.SMALL)
    },
    transportOptionsAsSelectBoxOptions () {
      return this.transportOptions.map((option: any) => ({
        label: option.label,
        value: option.value,
        hasCalendarException: option.hasCalendarException
      }))
    },
    hasSelectedTransportCalendarException () {
      if (this.isDeliveryDateFallback || this.isGigyaFallback) return false
      return this.transportOptions.some(
        (option: any) => option.value === this.selectedOrderType && option.hasCalendarException
      )
    },
    cartItems () {
      let cartItems: Array<{productid: string}> = []
      if (this.items.length) {
        cartItems = this.items.map((item: BaseCartQueryItem) => {
          return { productId: item.product.sku }
        })
      }
      return cartItems
    },
    isOnHomepage () {
      return this.$route.path === '/'
    },
    isFavoritePage () {
      return this.$route.path === '/catalog/favorites'
    },
    defaultShipTo () {
      return this.$store.state.auth.defaultShipTo
    },
    shipToOptionsForExceptions (): ShipToOptions {
      const { permissionSchema = [] } = this.user || {}
      return permissionSchema
        .filter((permission: any) =>
          permission.rpDetails.some((role: any) => role.permission.includes('Catalogue') && permission.shipToStatus === 'APPROVED')
        )
        .map((permission: any) => ({
          label: permission.shipToName,
          shipToId: permission.shipToId,
          description: permission?.shipToAddress
        }))
    },
    shipToForExceptions (): string {
      return this.shipToOptionsForExceptions.map((item: any) => item.shipToId).join(',')
    },
    hasAnyShipToException (): boolean {
      if (this.isDeliveryDateFallback || this.isGigyaFallback) return false
      return this.calendarException && this.calendarException.length > 0
    },
    showOrderWarning (): boolean {
      return this.hasAnyShipToException || (this.cashFilledPercentage > 0 && this.cashFilledPercentage < 100)
    }
  },
  methods: {
    extractCatalogData (data: HeaderData[]) {
      const findByName = (list: HeaderData[]): HeaderData | undefined => {
        for (const item of list) {
          if (item?.name === CREATE_ORDER_NAME) return item
          if (item?.children?.length) {
            const found = findByName(item.children)
            if (found) return found
          }
        }
      }
      const target = findByName(data)
      this.addToCartLabel = target?.label || ''
    },
    navigateToPath (link: NavigateLink) {
      this.$gtm.trackEvent({ ecommerce: null })
      this.$gtm.trackEvent({
        event: 'click_interaction',
        action: link.label,
        component: 'header'
      })
      this.$navigate(link.href || link.link || '')
    },
    checkUnfilteredAreEnabled () {
      const shipment = this.user.permissionSchema.find((permission:any) => permission.shipToId === this.selectedShipmentId)
      return shipment?.isUnfilteredEnabled
    },
    checkTankEnabled () {
      const shipment = this.user.permissionSchema.find((permission:any) => permission.shipToId === this.selectedShipmentId)
      return shipment?.isTankEnabled
    },
    handleDatePickerOpen () {
      this.isDatePickerOpen = true
    },
    handleDatePickerClose () {
      this.isDatePickerOpen = false
    },
    toggleAccordion (event: any) {
      this.isExpanded = event.target.getAttribute('aria-expanded') === 'true'
    },
    setShipmentWrapper (value: string) {
      if (!localStorage.getItem('isSuggestedModified') || localStorage.getItem('isSuggestedModified') === 'false') {
        if (this.items?.length > 0) {
          this.setContinueModalMessages(
            this.$t('You have a basket in progress for a ship to with the date of delivery', { place: this.currentShippingPlace?.description || '', date: this.formateDateWithoutLocale(this.deliveryDateSelected) }),
            this.$t('Continue ordering with current ship to.', { place: this.currentShippingPlace?.description || '' }),
            this.$t('Start a new order with new ship to . Products from the cart will be removed.', { place: this.getShippingDescription(value) }))
          this.bufferedSelection = { type: 'setShipment', value }
          return this.openOrderModal()
        } else {
          this.setContinueModalMessages('', '', '')
          this.setShipment(value, true)
        }
      } else {
        modals.showConfirmModal({
          title: this.$t('Suggested Cart').toUpperCase(),
          message: this.$t('You are editing the suggested cart. Would you like to revert it to its default value?'),
          cancel: this.$t('No, stay and edit'),
          confirm: this.$t('Yes, exit')
        }).then(() => {
          localStorage.removeItem('isSuggestedModified')
          localStorage.removeItem('suggestedCartAmounts')
          this.setShipment(value, true)
        })
      }
    },
    getShippingDescription (value: string) {
      const shipTo = this.shipToOptions.find((option: any) => option.value === value)
      return shipTo?.description || ''
    },
    async setShipment (value: string, isDropDownChange = false) {
      this.errorMsg = ''
      this.selectedShipmentId = value
      if (value) {
        localStorage.setItem('shipToId', value)
      }
      // 🔹 Validate if ShipTo is disabled
      if (this.checkDisableShipTo(this.user, this.selectedShipmentId)) {
        this.errorMsg = this.$t('ShipTo suspended - Select another ShipTo')
        return
      }
      try {
        await this.$store.commit('basket/SET_LOADING', true, { root: true })
        // 🔹 Fetch ShipTo details
        await this.$store.dispatch('catalog/FETCH_SHIP_TO', { ship_to_id: this.selectedShipmentId }, { root: true })
        if (this.shipTos) {
          this.shipmentSet = true
          if (this.selectedOrderType === TransportationTypes.POSM) { this.fetchPosmBudget() }
          // Reset transport type based on ShipTo
          this.setDefaultTransportType()
          // Fetch available delivery dates for this ShipTo + transport type
          await this.fetchAvailableDates(this.selectedShipmentId, this.selectedOrderType)
          // Update selection handler (dropdown vs restore)
          this.onOrderTransportTypeSelection(this.selectedOrderType, isDropDownChange)
        }
        // 🔹 If not homepage, fetch recommended products
        if (!this.isOnHomepage) {
          await this.$store.dispatch('catalog/FETCH_RECOMMENDED_PRODUCTS', {
            shipTo: this.selectedShipmentId,
            cartItems: this.cartItems
          }, { root: true })
        }
        // 🔹 Fetch suggested cart
        if (this.isGroupedViewEnabled) {
          await this.$store.dispatch('basket/FETCH_SUGGESTED_CART_GROUPED', { ship_tos: [this.selectedShipmentId], group_view: false })
        } else {
          await this.$store.dispatch('basket/FETCH_SUGGESTED_CART', { ship_tos: [this.selectedShipmentId], group_view: false })
        }
      } catch (error) {
        console.error('shipment error', error)
        this.errorMsg = 'Error setting shipment'
      } finally {
        await this.$store.commit('basket/SET_LOADING', false, { root: true })
      }
      // 🔹 Fire custom event
      const companyId = this.getCompanyid(this.selectedShipmentId, this.user)
      const event = new CustomEvent('setShipment', {
        detail: {
          type: 'delivery-options',
          shipTo: this.selectedShipmentId,
          payer: companyId
        }
      })
      document.dispatchEvent(event)
      await this.$store.dispatch('deliveryDates/FETCH_NOTIFICATION_EXCEPTION', {
        guid: this.user.UID || '',
        shipTo: this.shipToForExceptions,
        store: localStorage.getItem('store') || ''
      })
    },
    setDefaultTransportType () {
      const lastCustomerSettings: LastCustomerSettings | null = this.customerSettings || null
      const alreadySelectedShippingMethod = localStorage.getItem('shippingMethod') ?? ''
      const isAvailable = this.transportOptions.findIndex((option:any) => option.value === alreadySelectedShippingMethod) >= 0

      // 🔹 If cart has items, use last saved transport type
      if (this.items?.length > 0 && lastCustomerSettings?.delivery_method) {
        this.selectedOrderType = lastCustomerSettings.delivery_method
        return
      }
      // 🔹 Otherwise, use saved value in localStorage
      if (alreadySelectedShippingMethod !== 'undefined' && alreadySelectedShippingMethod !== undefined && alreadySelectedShippingMethod !== '' && alreadySelectedShippingMethod !== null && isAvailable) {
        this.selectedOrderType = alreadySelectedShippingMethod
      } else if (this.filteredTransportOptions.map((option: any) => option.value).includes(TransportationTypes.SMALL)) {
        this.selectedOrderType = 'selfpickup_selfpickup'
      } else {
        this.selectedOrderType = this.filteredTransportOptions[0]?.value || ''
      }
    },
    getCompanyid (shipToId: string, user: IAuthUser) {
      let companyId = ''
      const shipToItem = user?.permissionSchema.find((item: permissionSchema) => item.shipToId === shipToId)
      if (shipToItem) {
        companyId = shipToItem?.companyId
      }
      return companyId
    },
    checkDisableShipTo (user: IAuthUser, shipToId: string) {
      const permissionSchema = user?.permissionSchema || []
      if (shipToId != null) {
        return permissionSchema.some(
          (shipToItem: permissionSchema) => shipToItem.shipToId === shipToId && shipToItem.shipToStatus === 'SUSPENDED'
        )
      }
      if (permissionSchema.length === 1) {
        return permissionSchema[0]?.shipToStatus === 'SUSPENDED'
      }
      return false
    },
    async startYourOrder () {
      const errorMsg = []
      if (this.selectedOrderType === '') errorMsg.push(this.$t('Order type has to not be empty!'))
      if (this.deliveryDateSelected === '') errorMsg.push(this.$t('Delivery date has to not be empty!'))
      if (errorMsg.length > 0) {
        // this.errorMsg = errorMsg[0]
        return
      }
      if (!validateDeliveryDate(this.deliveryDateSelected, this.selectedOrderType, this.shipTos, getHolidayDays(this.holidaysConfig)) &&
      !isExceptionDeliveryDate(this.$store.state.deliveryDates.notificationExceptions, localStorage.getItem('shipToId') ?? '', this.deliveryDateSelected, this.selectedOrderType as TransportationTypes)) {
        (this.$refs.deliveryDatePickerRef as InstanceType<typeof DeliveryDatePicker>)?.forceRecalculate()
        errorMsg.push(this.$t('Shipping cannot be ordered. Choose a different date.'))
      }
      if (errorMsg.length > 0) {
        this.errorMsg = errorMsg[0]
        return
      }
      // get new orderable units based on new order type
      this.$store.dispatch('main/FETCH_ORDERABLE_UNITS_CONFIG',
        {
          customerType: localStorage.getItem('customertype'),
          orderType: this.selectedOrderType
        }, { root: true })
      setDeliveryDate(this.deliveryDateSelected, this.selectedOrderType)
      this.$store.commit('basket/SET_DELIVERY_DATE', this.deliveryDateSelected, { root: true })
      await this.$store.dispatch(
        'basket/FETCH_TRANSPORT_TYPE',
        { transporttype: this.selectedOrderType, cart_id: this.id },
        { root: true }
      )
      try {
        // 🔹 Start loader
        await this.$store.commit('basket/SET_LOADING', true, { root: true })

        // 🔹 Get new orderable units
        await this.$store.dispatch(
          'main/FETCH_ORDERABLE_UNITS_CONFIG',
          {
            customerType: localStorage.getItem('customertype'),
            orderType: this.selectedOrderType
          },
          { root: true }
        )
        // 🔹 Set delivery date in store
        setDeliveryDate(this.deliveryDateSelected, this.selectedOrderType)
        this.$store.commit('basket/SET_DELIVERY_DATE', this.deliveryDateSelected, { root: true })

        // 🔹 Fetch transport type
        await this.$store.dispatch(
          'basket/FETCH_TRANSPORT_TYPE',
          { transporttype: this.selectedOrderType, cart_id: this.id },
          { root: true }
        )

        // 🔹 Prepare API calls
        const ajaxRequests = [
          this.$store.dispatch('basket/FETCH_MIN_CART_QUERY_FOR_CATALOG', { cart_id: this.id }, { root: true })
        ]
        if (!this.isOnHomepage && !this.isFavoritePage) {
          const hasOnlyFlexible = this.$route.query.checkYourFlexible
          ajaxRequests.push(this.$store.dispatch('catalog/FETCH_PRODUCTS', { fetchPolicy: 'network-only', package_type: hasOnlyFlexible ? 'Flexible' : '' }, { root: true }))
        }
        if (this.$store.state.catalog.openedProduct != null) {
          ajaxRequests.push(this.$store.dispatch('catalog/FETCH_PRODUCT', { sku: this.$store.state.catalog.openedProduct.sku }, { root: true }))
        }
        ajaxRequests.push(await this.$store.dispatch('catalog/FETCH_RECOMMENDED_PRODUCTS', {
          shipTo: this.selectedShipmentId,
          cartItems: this.cartItems
        }, { root: true }))
        ajaxRequests.push(
          this.$store.dispatch('basket/FETCH_SUGGESTED_CART', { ship_tos: [this.selectedShipmentId] })
        )
        await Promise.all(ajaxRequests)
      } catch (error) {
        console.error('order modal error', error)
      }
    },
    async fetchAvailableDates (shipToId: string, transportType: string) {
      // Helper: wait for shipmentId until it’s available
      const waitForShipmentId = async (retries = 10, delay = 200): Promise<string> => {
        for (let i = 0; i < retries; i++) {
          const shipmentId = localStorage.getItem('shippingMethod') || transportType || this.selectedOrderType || ''
          if (shipmentId) return shipmentId
          await new Promise(resolve => setTimeout(resolve, delay))
        }
        return ''
      }

      // 🔹 Wait until storeId and shipmentId are ready
      const storeId = localStorage.getItem('store') || ''
      const shipmentId = await waitForShipmentId()

      // 🧩 Validate required parameters
      if (!storeId) {
        console.warn('[Delivery API] Skipping fetchAvailableDates → storeId missing')
        return
      }

      if (!shipmentId) {
        console.warn('[Delivery API] Skipping fetchAvailableDates → shipmentId not found after waiting')
        return
      }

      if (!shipToId) {
        console.warn('[Delivery API] Skipping fetchAvailableDates → shipToId missing')
        return
      }
      try {
        await this.$store.dispatch('deliveryDates/GET_DELIVERY_AVAILABLE_DATE', {
          shipTo: shipToId,
          shipmentId,
          store: storeId
        })
      } catch (err) {
        console.error('[Delivery API] Error fetching available dates:', err)
      }
    },
    async initDefaultShipmentId () {
      // 🔹 Step 1: Fetch basket id
      let basketId = ''
      try {
        basketId = await this.$store.dispatch('basket/FETCH_BASKET_ID', {}, { root: true })
      } catch (err) {
        console.error('Error fetching basket ID:', err)
        return
      }

      // 🔹 Step 2: Fetch cart
      try {
        await this.$store.dispatch('basket/FETCH_HP_CART_QUERY', { cart_id: this.id }, { root: true })
      } catch (err) {
        console.error('Error fetching cart:', err)
      }
      await this.$nextTick()

      const cartItems = this.items || []
      const lastCustomerSettings: LastCustomerSettings | null = this.customerSettings || null
      const storedShipTo = localStorage.getItem('shipToId') ?? ''
      const storedShippingMethod = localStorage.getItem('shippingMethod') ?? ''
      const storedDeliveryDate = localStorage.getItem('deliveryDate') ?? ''
      const cartShippingMethod = this.query?.delivery_method

      // 🔹 Step 3: Resolve selectedShipmentId
      const validShipToValues = this.shipToOptions.map((option: any) => option.value)
      const isKnownShipTo = (value: string | null | undefined) => !!value && (validShipToValues.length === 0 || validShipToValues.includes(value))

      const candidateShipTo = (cartItems.length > 0 && lastCustomerSettings?.ship_to_id) || storedShipTo || ''

      this.selectedShipmentId =
    (isKnownShipTo(candidateShipTo) && candidateShipTo) ||
    this.shipToOptions[0]?.value ||
    ''
      localStorage.setItem('shipToId', this.selectedShipmentId)

      // 🔹 Step 4: Apply shipToId (skip API call if cart has items)
      if (this.selectedShipmentId) {
        if (cartItems.length === 0) {
          await this.setShipment(this.selectedShipmentId)
        } else {
          await this.$store.dispatch('deliveryDates/FETCH_NOTIFICATION_EXCEPTION', {
            guid: this.user.UID || '',
            shipTo: this.selectedShipmentId,
            store: localStorage.getItem('store') || ''
          })
          console.log('[Init] Skipping setShipment (cart has items)')
          await this.setShipment(this.selectedShipmentId)
        }
      }

      // 🔹 Step 5: Restore shipping method
      this.selectedOrderType = [
        storedShippingMethod,
        lastCustomerSettings?.delivery_method,
        this.selectedOrderType,
        cartShippingMethod
      ].find(v => v != null && v !== undefined && v !== '')

      const isGigyaFallback = this.$store.state.auth.isGigyaFallback
      const isDeliveryDateFallback = this.$store.state.deliveryDates.isDeliveryDateFallback
      const fallBackOrderTypes = ['emptiespickup_emptiespickup', 'selfpickup_selfpickup']
      if ((isGigyaFallback || isDeliveryDateFallback) && !fallBackOrderTypes.includes(this.selectedOrderType)) {
        this.selectedOrderType = 'selfpickup_selfpickup'
        localStorage.setItem('shippingMethod', this.selectedOrderType)
        this.startYourOrder()
      } else {
        localStorage.setItem('shippingMethod', this.selectedOrderType)
      }

      // 🔹 Step 6: Handle delivery date
      const savedDate = storedDeliveryDate || lastCustomerSettings?.delivery_date || ''

      let apiDates: string[] = []
      let finalDate = savedDate
      let found = false
      if (this.filteredDeliveryDates.length > 0) {
        found = this.filteredDeliveryDates.find((date: string) => date.startsWith(savedDate))
      }

      const hasCartItems = cartItems.length > 0
      const hasValidSavedDate = !!savedDate && !!found

      if (hasCartItems && hasValidSavedDate) {
        finalDate = savedDate
      } else {
        if (this.selectedShipmentId && this.selectedOrderType && this.filteredDeliveryDates.length === 0) {
          await this.fetchAvailableDates(
            this.selectedShipmentId,
            this.selectedOrderType
          )
        }

        apiDates = (this.filteredDeliveryDates || []).map((d: string) =>
          new Date(d).toLocaleDateString('en-CA')
        )

        finalDate = apiDates[0] || ''

        if (hasCartItems) {
          setDeliveryDate(finalDate, this.selectedOrderType)

          await this.$store.dispatch(
            'basket/FETCH_TRANSPORT_TYPE',
            {
              transporttype: this.selectedOrderType,
              cart_id: this.id
            },
            { root: true }
          )

          await this.$store.dispatch(
            'basket/FETCH_CART_QUERY',
            { cart_id: this.id },
            { root: true }
          )
        }
      }

      const isPOSM = this.selectedOrderType === TransportationTypes.POSM
      if (isPOSM) {
        let availableDays = this.availableDays
        const datesMap = this?.posmInventoryDates
        const shipToId = this?.selectedShipmentId
        if (datesMap && shipToId) {
          const range = datesMap.posm
          if (Array.isArray(range) && range.length >= 2) {
            const fromTime = this.toTime(range[0])
            const toTimeVal = this.toTime(range[1])
            availableDays = availableDays.filter((availableDate:string) => {
              const date = new Date(availableDate)
              const availableDateTime = this.toTime(date)
              if (availableDateTime === null || fromTime === null || toTimeVal === null) return true
              return availableDateTime > toTimeVal || availableDateTime < fromTime
            })
          }
          const modelDate = new Date(finalDate)
          const firstAvailabledDate = new Date(availableDays[0])

          if (modelDate < firstAvailabledDate) {
            const formattedFirstAvailabledDate = firstAvailabledDate.getFullYear() + '-' + String(firstAvailabledDate.getMonth() + 1).padStart(2, '0') + '-' + String(firstAvailabledDate.getDate()).padStart(2, '0')
            finalDate = formattedFirstAvailabledDate
          }
        }
      }

      // 🔹 Step 7: Finalize delivery date selection
      this.deliveryDateSelected = finalDate
      localStorage.setItem('deliveryDate', this.deliveryDateSelected)
      this.$store.commit('basket/SET_DELIVERY_DATE', this.deliveryDateSelected, { root: true })

      // 🔹 Step 8: Fetch holidays (only if missing)
      if (!this.holidaysConfig || this.holidaysConfig?.holidays?.length === 0) {
        await this.$store.dispatch('main/FETCH_HOLIDAYS_CONFIG', { root: true })
      }
    },
    onOrderTransportTypeSelectionWrapper (value: string) {
      const defaultNonEmptyTransportType = ['flatrate_flatrate', 'selfpickup_selfpickup', 'freeshipping_freeshipping', 'tank_tank', 'posm_posm']
      if (defaultNonEmptyTransportType.includes(value)) {
        localStorage.setItem('onlyEmpties', JSON.stringify(0))
      } else {
        localStorage.setItem('onlyEmpties', JSON.stringify(1))
      }

      if (!localStorage.getItem('isSuggestedModified') || localStorage.getItem('isSuggestedModified') === 'false') {
        if (this.items?.length > 0) {
          this.bufferedSelection = { type: 'onOrderTransportTypeSelection', value }
          return this.openOrderModal()
        } else {
          this.onOrderTransportTypeSelection(value, true)
        }
      } else {
        modals.showConfirmModal({
          title: this.$t('Suggested Cart').toUpperCase(),
          message: this.$t('You are editing the suggested cart. Would you like to revert it to its default value?'),
          cancel: this.$t('No, stay and edit'),
          confirm: this.$t('Yes, exit')
        }).then(() => {
          localStorage.removeItem('isSuggestedModified')
          localStorage.removeItem('suggestedCartAmounts')
          this.onOrderTransportTypeSelection(value, true)
        })
      }
    },
    async onOrderTransportTypeSelection (value: string, isDropDownChange = false) {
      // Step 1: set selected transport type
      this.selectedOrderType = value
      await this.$store.commit('basket/SET_SHIPMENT_ID', this.selectedOrderType, { root: true })

      // Step 2: fetch available dates from API
      const selectedShipTo = localStorage.getItem('shipToId') || this.shipToOptions[0]?.value
      const storeId = localStorage.getItem('store')
      localStorage.setItem('shippingMethod', value)

      if ((selectedShipTo && storeId) || value === TransportationTypes.UNFILTERED) {
        await this.fetchAvailableDates(selectedShipTo, this.selectedOrderType)
        await this.$nextTick()
      }

      // Step 3: process available dates
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const todayStr = today.toLocaleDateString('en-CA')

      const availableDates = (this.filteredDeliveryDates || []).map((d: string) => {
        // ensure ISO date format (YYYY-MM-DD)
        return new Date(d).toLocaleDateString('en-CA')
      })

      if (value === TransportationTypes.UNFILTERED) {
        this.deliveryDateSelected = availableDates[0]
        localStorage.setItem('deliveryDate', availableDates[0])
      }

      // --- Step 4: pick the chosen date ---
      const chosenDate = availableDates[0] || todayStr
      this.deliveryDateSelected = chosenDate
      localStorage.setItem('deliveryDate', chosenDate)

      // Step 5: update deliveryDateSelected + localStorage
      this.deliveryDateSelected = chosenDate
      localStorage.setItem('deliveryDate', chosenDate)

      const isPOSM = value === TransportationTypes.POSM
      if (isPOSM) {
        let availableDays = this.availableDays
        const datesMap = this?.posmInventoryDates
        const shipToId = this?.selectedShipmentId
        if (datesMap && shipToId) {
          const range = datesMap.posm
          if (Array.isArray(range) && range.length >= 2) {
            const fromTime = this.toTime(range[0])
            const toTimeVal = this.toTime(range[1])
            availableDays = availableDays.filter((availableDate:string) => {
              const date = new Date(availableDate)
              const availableDateTime = this.toTime(date)
              if (availableDateTime === null || fromTime === null || toTimeVal === null) return true
              return availableDateTime > toTimeVal || availableDateTime < fromTime
            })
          }
          const modelDate = new Date(chosenDate)
          const firstAvailabledDate = new Date(availableDays[0])

          if (modelDate < firstAvailabledDate) {
            const formattedFirstAvailabledDate = firstAvailabledDate.getFullYear() + '-' + String(firstAvailabledDate.getMonth() + 1).padStart(2, '0') + '-' + String(firstAvailabledDate.getDate()).padStart(2, '0')
            this.deliveryDateSelected = formattedFirstAvailabledDate
            localStorage.setItem('deliveryDate', formattedFirstAvailabledDate)
          }
        }
      }

      this.startYourOrder()

      await this.$store.commit('basket/SET_TRANSPORT_TYPE', {
        transporttype: this.computedSelectedOrderType
      })

      await this.$store.dispatch('catalog/FETCH_FAVORITES', { pageSize: 25 }, { root: true })
      if (!this.isOnHomepage && !this.isFavoritePage) {
        const hasOnlyFlexible = this.$route.query.checkYourFlexible
        await this.$store.dispatch('catalog/FETCH_PRODUCTS', { fetchPolicy: 'network-only', package_type: hasOnlyFlexible ? 'Flexible' : '' }, { root: true })
      }
    },
    openOrderModal () {
      modals.showModal({
        component: ContinueShoppingModal,
        listeners: {
          doSelection: () => {
            this.doSelection()
            this.setContinueModalMessages('', '', '')
          }
        }
      })
    },
    setContinueModalMessages (title: string, continueMsg: string, newMsg: string) {
      this.$store.commit('catalog/SET_CONTINUE_MODAL_TITLE', title)
      this.$store.commit('catalog/SET_CONTINUE_MODAL_CONTINUE_MESSAGE', continueMsg)
      this.$store.commit('catalog/SET_CONTINUE_MODAL_NEW_MESSAGE', newMsg)
    },
    doSelection () {
      if (this.bufferedSelection?.type && this.bufferedSelection.value) {
        switch (this.bufferedSelection?.type) {
          case 'onOrderTransportTypeSelection' :
            this.onOrderTransportTypeSelection(this.bufferedSelection.value, true)
            break
          case 'setShipment' :
            this.setShipment(this.bufferedSelection.value, true)
            break
          case 'onDateSelection' :
            this.onDateSelection(this.bufferedSelection.value)
            break
        }
      }
      this.bufferedSelection = {}
    },

    toTime (value:string | Date): number | null {
      if (!value) return null
      const d = new Date(value)
      return Number.isNaN(d.getTime()) ? null : d.getTime()
    },
    onDateSelectionWrapper (valueWrapper: any) {
      const today = new Date(new Date().toDateString())
      const value = typeof valueWrapper === 'string' ? valueWrapper : valueWrapper.value
      let localDate = localStorage.getItem('deliveryDate')
      // Remove expired local date
      if (localDate && new Date(localDate) < today) {
        localStorage.removeItem('deliveryDate')
        localDate = ''
      }
      this.deliveryDateSelected = localDate || this.filteredDeliveryDates[0]
      if (this.items?.length > 0 && !valueWrapper.isFirstAvailable) {
        (this.$refs.deliveryDatePickerRef as InstanceType<typeof DeliveryDatePicker>)?.forceRecalculate()
        this.setContinueModalMessages(
          this.$t('You have a basket in progress for a collection point with the date of delivery', {
            place: this.currentShippingPlace?.description || '',
            date: this.formateDateWithoutLocale(this.deliveryDateSelected)
          }),
          this.$t('Continue ordering with current date'),
          this.$t('Start a new order with new delivery date. Products from the cart will be removed.', {
            date: this.formateDateWithoutLocale(value)
          })
        )
        this.bufferedSelection = { type: 'onDateSelection', value }
        return this.openOrderModal()
      } else {
        this.setContinueModalMessages('', '', '')
        this.onDateSelection(value)
      }
    },
    onDateSelection (date: string) {
      this.deliveryDateSelected = date
      setDeliveryDate(this.deliveryDateSelected, this.selectedOrderType)
      if (!this.selectedOrderType) {
        this.selectedOrderType = localStorage.getItem('shippingMethod') ?? ''
      }
      this.$store.commit('basket/SET_DELIVERY_DATE', this.deliveryDateSelected, { root: true })
      this.startYourOrder()
    },
    computedSelectedOrderType (): string {
      if (!this.orderInfo || !this.orderInfo.deliveryTransportId) return ''
      switch (this.orderInfo.deliveryTransportId) {
        case 'YDOR':
          return 'selfpickup_selfpickup'
        case 'YSE1':
          return 'emptiesfulltruck_emptiesfulltruck'
        case 'YDE1':
          return 'emptiespickup_emptiespickup'
        case 'YSOR':
          return 'flatrate_flatrate'
        default:
          return ''
      }
    },
    async displayCalendarExceptionModal () {
      await modals.showCalendarExceptionModal(this.calendarException)
    },
    hasCalendarExceptionForCurrentSelection (transportType: string): boolean {
      if (this.isDeliveryDateFallback || this.isGigyaFallback) return false
      const selected = this.shipToOptions.find(option => option.value === this.selectedShipmentId)
      if (transportType === mapTransportType(TransportationTypes.EMPTY_SMALL) ||
      transportType === mapTransportType(TransportationTypes.SMALL_TRUCK)) {
        return this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.SMALL))
      }
      if (transportType === mapTransportType(TransportationTypes.EMPTY_TRUCK)) {
        return this.hasCalendarExceptionForCurrentSelection(mapTransportType(TransportationTypes.TRUCK))
      }
      return (selected?.hasCalendarException && this.calendarException.some(
        (exception: CalendarExceptions) => exception.shipToId === selected.value && exception.deliveryExceptions.some((delivery) => delivery.transportation === transportType))) || false
    },
    hasShipToCalendarException (permission: any) {
      if (this.isDeliveryDateFallback || this.isGigyaFallback) return false
      return this.calendarException.some(
        (exception: any) =>
          exception.deliveryExceptions?.some((transportation: any) =>
            transportation.deliveryExceptions?.some(
              (de: any) => de.shipToId === permission.shipToId
            )
          )
      )
    },
    async removeItemInner (id: string) {
      await this.$store.dispatch('basket/REMOVE_ITEM', { cart_id: this.id, cart_item_id: id }, { root: true })
    },
    async cancel () {
      await this.$store.dispatch('basket/REMOVE_ALL_ITEMS', { cart_id: this.id }, { root: true })
    },
    async _handleFallback () {
      const expectedDate = this.$store.state.deliveryDates.availableDays[0] || ''
      const currentDate = this.deliveryDateSelected || localStorage.getItem('deliveryDate') || ''
      const isOrderTypeMismatch = this.selectedOrderType !== 'selfpickup_selfpickup'
      const isDateMismatch = currentDate.slice(0, 10) !== expectedDate.slice(0, 10)
      if (isOrderTypeMismatch || isDateMismatch) {
        if (isOrderTypeMismatch) {
          try {
            if (!this.id || this.id === '') {
              await this.$store.dispatch('basket/FETCH_BASKET_ID', {}, { root: true })
              await this.$store.dispatch('basket/FETCH_CART_QUERY', { cart_id: this.id }, { root: true })
            }
            if (this.items?.length > 0) {
              await this.cancel()
            }
            await this.onOrderTransportTypeSelection('selfpickup_selfpickup', true)
          } catch {
            console.log('error on resetStore')
          }
        } else if (isDateMismatch && expectedDate) {
          await setDeliveryDate(expectedDate, this.selectedOrderType)
          this.deliveryDateSelected = expectedDate
        }
      }
    },
    fetchPosmBudget () {
      const shipToId = localStorage.getItem('shipToId')
      this.$store.dispatch(CommonActionType.FETCH_BUDGET_POSM, { shipToId })
    }
  },
  async mounted () {
    // const defaultShipmentId = this.defaultShipTo ?? ''
    // if (defaultShipmentId) {
    //   localStorage.setItem('shipToId', defaultShipmentId)
    // }
    if (!this.id || this.id === '') {
      await this.$store.dispatch('basket/FETCH_BASKET_ID', {}, { root: true })
      await this.$store.dispatch('basket/FETCH_CART_QUERY', { cart_id: this.id }, { root: true })
    }
    const orderType = this.selectedOrderType || localStorage.getItem('shippingMethod') || ''
    if (this.isGigyaFallback && orderType !== 'selfpickup_selfpickup') {
      await this.cancel()
      await this.onOrderTransportTypeSelection('selfpickup_selfpickup', true)
    }
    if (!this.query.ship_to_id || this.query.ship_to_id === '') {
      await this.initDefaultShipmentId()
    } else {
      await this.initDefaultShipmentId()
      if (!this.holidaysConfig || this.holidaysConfig?.holidays?.length === 0) {
        await this.$store.dispatch('main/FETCH_HOLIDAYS_CONFIG', { root: true })
      }
    }
    this.$store.commit('basket/SET_SHIPMENT_ID', this.selectedOrderType, { root: true })
    this.extractCatalogData(this.portalPageMenuLink)
  },
  watch: {
    availableDate: {
      handler (newDate, oldValue) {
        this.deliveryDate = newDate
      },
      immediate: true
    },
    $route: {
      handler (nextVal) {
        this.hideCta = nextVal?.meta?.hideCreateOrderButton as boolean || false
      },
      immediate: true,
      deep: true
    },
    shipToOptions (newVal) {
      if (newVal && newVal.length > 0 && !this.selectedShipmentId) {
        this.initDefaultShipmentId()
      }
    },
    portalPageMenuLink (newData) {
      this.extractCatalogData(newData)
    },
    async isDeliveryDateFallback (newVal) {
      if (!newVal) return
      await this._handleFallback()
    },
    async isGigyaFallback (newVal) {
      if (!newVal) return
      await this._handleFallback()
    }
  }
})
